import api from '@/utils/api';

/**
 * 轮播图相关接口
 */

/**
 * 获取轮播图列表
 * @returns {Promise}
 */
export function getCarouselList() {
  return api.get('/carousel/index');
}

